import * as React from "react";

function MembersIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.7 5C5.7 2.624 7.624.7 10 .7s4.3 1.924 4.3 4.3-1.924 4.3-4.3 4.3A4.299 4.299 0 015.7 5zm-5 11.25c0-.574.282-1.129.868-1.67.59-.545 1.442-1.027 2.44-1.427 2-.8 4.41-1.203 5.992-1.203 1.581 0 3.993.402 5.991 1.203.999.4 1.85.882 2.441 1.427.586.541.868 1.096.868 1.67v3.05H.7v-3.05z"
        stroke="currentColor"
        strokeWidth={1.4}
      />
    </svg>
  );
}

export default MembersIcon;
